export default {
  common: {
    adminFunction: "系统管理", //"Administrator function",
    ecatLibrary: "e-CAT 库",
    accountManagement: "账号管理",
    accountPermission: "管理用户账号和权限",
    regionManagement: "区域管理",
    zoneCountryCity: "更新地区，国家和城市信息",
    cityWeatherManagement: "城市天气数据",
    weatherProfileBaseOnCity: "更新城市的天气配置文件",
    ecatDataManagement: "e-CAT 数据管理",
    digitalEcatLibrary: "数字 e-CAT 库",
    ecatLibraryEquipmentsModels: "更新 e-CAT 实验设备和模型",
    cancel: "取消",
    save: "保存",
    permission: "权限表",
    noAccountInfo: "无账号信息",

    customerFeedback: "用户反馈",
    viewFeedbackList: "显示所有用户的反馈信息",
    globalUnitPreferences: "全局单位偏好设置",

    unitSetting: "单位设置",
    usefulTools: "实用工具",
    efficiency: "效率"
  },
  account: {
    inputUserName: "请输入用户名",
    thereAreNoMoreUsersLeft: "没有更多用户",
    superAdmin: "超级管理员",
    global: "全球的",
    region: "区域",
    regional: "区域的",
    zoneCountry: "国家",
    city: "城市",
    segmentMegaCity: "细分（特大城市）",
    status: "账号状态",
    activeStatus: "激活状态",
    role: "账号角色",
    active: "已激活",
    inactive: "未激活",
    fillRole: "请选择角色",

    multiRegional: "多个区域",
    multiZoneCountry: "多个国家",
    singleZoneCountry: "单个国家",
    otherRegions: "其他区域",
    otherZones: "其他国家"
  },
  feedback: {
    yourOpinionImportant: "您的意见很重要",
    tellYourExperience: "请告诉我们您的使用体验",
    detailedFeedback: "请输入您的反馈",
    provideDetailedYourOpinionssuggestions: "请详细描述您的意见和建议, 您可以从【我的】->【我的反馈】中再次打开此页面。",
    submitFeedback: "提交反馈",
    ifProblemsContact: "如果您有任何问题，请联系",
    localAdministrator: "当地支持",
    noFeedback: "没有反馈",
    submissionSuccessful: "提交成功",
    myFeedback: "我的反馈",
    thereAreNoMoreFeedbackLeft: "没有更多用户反馈了"
  },
  digitalEcat: {
    publicEcatLib: "e-CAT库",
    myCustomized: "自定义库",
    chillerCapacity: "冷水机组容量",
    thereNoEcatLeft: "没有更多 e-CAT 数据了",
    capacityRange: "容量范围",
    compressorType: "压缩机类型",
    refrigerantType: "制冷剂类型",
    pleaseSelectOrEnter: "搜索模型或选择筛选条件",
    clickHereToSelectAJsonFile: "点击这里选择一个 JSON 文件",
    successfullyParsed: "成功解析 {modelsCount} 个模型",
    bearingType: "冷机轴承类型",
    manufacturingRegion: "产地",
    me: "我",
    libraryOwner: "库的所有者是",
    addSelfChillerModel: "添加自定义冷水机组模型",
    capacity: "容量",
    designCondenserTemp: "设计冷凝器温度",
    eCatPerformanceData: "e-CAT 性能数据",
    point4Data: "4 点数据",
    point10Data: "10 点数据",
    computerPreview: "性能曲线预览",
    previewChilledWaterTemp: "预览冷冻水供水温度",
    previewCondenserTemp: "预览冷却水供水温度",
    previewCondenserAirTemp: "预览冷凝器进风温度",
    compute: "计算",
    chillerType: "冷水机组类型",
    youAreCurrentlyUsingLibrary: "您当前正在使用 '{selectUserEmail}' 库，不允许修改或保存。",

    chillerModel: "冷机型号",
    modelNumber: "型号编号",
    objective: "目标",
    heatpumpType: "热泵类型",
    heatpumpFileParsed: "热泵文件解析成功",
    chillerFileParsed: "冷水机组文件解析成功",

    previewSourceWaterTemp: "预览热源水供水温度",
    previewSourceAirTemp: "预览热源空气温度",
    previewHotWaterTemp: "预览热水供水温度",

    deviceType: "设备类型",
    addSelfHeatPumpModel: "添加自有热泵模型",
    heatPumpModel: "热泵模型",
    selectEquipmentType: "选择设备类型",
    createACustomChillerModel: "创建自定义冷水机组模型",
    createACustomHeatPumpModel: "创建自定义热泵模型"
  },
  usefulTools: {
    asseesConfig: "评估将空气处理装置风扇升级为直接驱动配置的好处。",
    clickEnter: "点击进入",
    integratesTools: "该平台集成了所有升级和改造工具"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/zh.js